import { Link } from "react-router-dom";

export function BoNavigation() {
  return <footer className="navigation">
      <Link to="/">Terminübersicht</Link> &bull; <Link to="/terminbuchung">Sofort-Termin buchen</Link>
  </footer>;
}
